import styled from "styled-components";
import ButtonUi from "../../Button";
import { buttonStyles } from "../../Button/styles";

export const Button = styled(ButtonUi)<{ skin }>`
  justify-content: center;
`;
